const formatString = (template, ...args) => args.reduce((result, arg, i) => result.replace(`{${i}}`, arg), template);

const parseList = (string) => {
    if (!string) return [];

    return Array.from(string.matchAll(/<li>(.*?)<\/li>/g), (match) => match[1]);
};

const deepCloneData = (data) => {
    return JSON.parse(JSON.stringify(data));
};

const capitalizeFirstLetter = (string) => {
    return string.charAt(0).toUpperCase() + string.slice(1);
};

const stringUtils = {
    formatString,
    parseList,
    deepCloneData,
    capitalizeFirstLetter,
};

export default stringUtils;
